import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateWithMillis'
})
export class DateWithMillisPipe implements PipeTransform {

  transform(value: string | Date): string {
    
    if (!value) return '';

    const date = new Date(value);

    const pad = (num: number, size: number = 2) =>
      num.toString().padStart(size, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const millis = pad(date.getMilliseconds(), 3);

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}.${millis}`;
  }

}
